import { render, staticRenderFns } from "./demo-hint-button.vue?vue&type=template&id=63996b33&scoped=true&"
import script from "./demo-hint-button.vue?vue&type=script&lang=js&"
export * from "./demo-hint-button.vue?vue&type=script&lang=js&"
import style0 from "./demo-hint-button.vue?vue&type=style&index=0&id=63996b33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63996b33",
  null
  
)

export default component.exports